/**
 * Get the External Primary Event url
 * @param {Object} event
 * @return {String} url //event url
 */
export default (event = {}) => {
  return event.attributes ? event.attributes.externalWebURI : event.externalWebURI;
};
